import type { ElementType, ReactNode } from "react";

export function Eyebrow({ children }: { children: ReactNode }) {
  return <span className="eyebrow">{children}</span>;
}

export function SectionHeading({
  eyebrow,
  title,
  level = "h2"
}: {
  eyebrow?: string;
  title: ReactNode;
  level?: "h1" | "h2";
}) {
  const Heading = level as ElementType;

  return (
    <div className="section-heading">
      {eyebrow ? <Eyebrow>{eyebrow}</Eyebrow> : null}
      <Heading>{title}</Heading>
    </div>
  );
}
